export type AudioFilter = 'music' | 'voice' | 'music_voice' | 'none';

const audioFilterLabels: Record<AudioFilter, string> = {
  music: 'Music Only',
  voice: 'Voice Only',
  music_voice: 'Music and Voice',
  none: 'None',
};

export interface AudioFilterSelection {
  key: AudioFilter;
  display: string;
}

function isAudioFilter(value: string): value is AudioFilter {
  return Object.prototype.hasOwnProperty.call(audioFilterLabels, value);
}

export function getAudioFilterSelections(values: string[]): AudioFilterSelection[] {
  return values
    .filter(isAudioFilter)
    .map((value) => ({
      key: value,
      display: audioFilterLabels[value],
    }));
}
